import { render, staticRenderFns } from "./AttentionEventModal.vue?vue&type=template&id=0de50592&"
import script from "./AttentionEventModal.vue?vue&type=script&lang=js&"
export * from "./AttentionEventModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports